var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIconForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.64 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M98.64,15.39c0-8.48-6.7-15.39-14.96-15.39H14.96C6.71,0,0,6.9,0,15.39v6.01c0,.21,.02,.42,.06,.62-.04,.43-.06,.86-.06,1.3V156.62c0,8.47,6.71,15.38,14.96,15.38H83.68c8.25,0,14.96-6.9,14.96-15.38V23.32c0-.44-.02-.87-.06-1.3,.04-.2,.06-.41,.06-.62v-6.01Zm-7,109.04v7.92H7V24.9H91.64V124.43ZM59.77,12.46c0,1.27-.95,2.32-2.18,2.48h-16.54c-1.23-.16-2.18-1.21-2.18-2.48,0-.37,.08-.71,.22-1.02,.38-.87,1.26-1.48,2.28-1.48h15.9c1.02,0,1.9,.61,2.28,1.48,.14,.31,.22,.65,.22,1.02Zm-2.45,140.5c0,4.42-3.58,8-8,8s-8-3.58-8-8,3.59-8,8-8,8,3.58,8,8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconForm);
export default __webpack_public_path__ + "static/media/phoneIconForm.822175ea1eef1285b03af27f25fad4e7.svg";
export { ForwardRef as ReactComponent };